<template>
    <!-- <UnderConstruction /> -->
    <div class="p-md-3 w-100" >
      <div class="row pb-md-2 pb-3 pt-0">
        <div class="col-md-12 d-flex justify-content-start align-items-center">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb p-0 m-0">
              <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
              <li class="breadcrumb-item active" aria-current="page"> Partner Discount Codes</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-2" v-for="code in discountCodes" :key="code.id">
          <div class="card">
            <div class="d-flex card-header justify-content-between align-items-center">
                <h4 class="header-title">{{ code.code }}</h4> <button type="button" class="btn btn-primary" @click="copyText(code.code)"><i class="fa-duotone fa-solid fa-copy"></i></button>
            </div>
            <div class="card-body pt-0">
              <h2>{{ code.amount }} <span v-if="code.discount_type">%</span></h2>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
    
<script lang="js">
import { defineComponent } from 'vue'
// import UnderConstruction from '../components/UnderConstruction';
import Mixin from '../mixins/global.mixin'
import axios from 'axios';
import { mapState } from 'vuex'
import appConstants from '@/constants/app.constants';
  
export default defineComponent({
  name: 'DiscountCodes',
  mixins: [Mixin],
  computed: mapState([
      'isCollapse',
      'currentSessionEmail',
      'jwtToken',
      'currentSessionUserID',
      'currentSessionRailsID',
      'currentSessionRailsData'
  ]),
  data() {
    return {
      discountCodes: [],
    }
  },
  components: {
    // UnderConstruction
  },
  methods: {
    getPartnerCodes: function () {
      axios.get(appConstants.SITEURL+'/wp-json/wc/v3/coupons?search='+this.currentSessionRailsData.reseller_code, { headers: { "Authorization": appConstants.SITEAUTH}})
      .then((response) => {
        this.toggleFullScreenSpinner(false);
        this.discountCodes = response.data;
      }).catch(() => {
        this.toggleFullScreenSpinner(false);
      })
    }
  },
  beforeMount() {
    this.getRailsApplicationData();
  },
  mounted() {
    this.getPartnerCodes();
  }
});
</script>
    